import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ServicePointChristmas: FC<SvgIconProps> = ({ viewBox = '0 0 254 190', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#servicepoint_christmas_paint0_clip)">
      <path
        d="m101.275 40.49-2.25 3.275S89.2 47.477 86.54 53.153c0 0-3.274 3.93 0 38.64l49.318 1.31-3.888-39.95s-1.228-10.697-7.572-12.226c0 0-6.958-1.31-11.255-1.964l-11.869 1.528Z"
        fill="#E5E5E5"
      />
      <path d="m109.665 48.132.819 9.605 2.046-.436-.818-9.606-2.047.437Z" fill="#C9C9C9" />
      <path d="M101.071 36.998v3.493l9.413 7.422 3.274-8.732-12.687-2.183Z" fill="#DEA07B" />
      <path
        d="m85.927 85.899 5.116-1.092s-1.432-3.711-1.432-7.64c0-3.057-.41-8.296-.41-8.296s.41-8.951 2.047-13.099c1.637-4.148 10.641-9.169 10.641-9.169l-3.07-2.62s-5.115 2.184-8.39 4.803c0 0-4.502 2.183-4.91 8.514-.206 0-1.229 12.226.408 28.599Z"
        fill="#C9C9C9"
      />
      <path
        d="m101.07 40.49 9.414 7.423-2.456 4.148-9.209-8.296 2.251-3.275ZM96.16 61.448l.204 22.267 2.25-.218"
        fill="#8E8E8E"
      />
      <path
        d="m115.6 39.618 8.39 1.31s3.888.654 6.139 5.457c0 0 2.251 4.148 2.456 13.317l-1.024.437s-1.432-12.007-5.729-14.409c0 0-5.935-2.62-10.642-3.493l.41-2.62Z"
        fill="#F4F4F4"
      />
      <path
        d="m123.376 54.462 4.297 23.36-1.841.436M113.758 39.181l-3.274 8.732 3.683 2.184 1.433-10.48-1.842-.436Z"
        fill="#8E8E8E"
      />
      <path
        d="M119.897 25.21c.409 8.077-3.683 15.062-10.436 15.499-6.753.437-12.483-6.55-13.097-14.627-.41-8.295 1.637-14.845 10.641-14.845 8.799 0 12.483 5.895 12.892 13.972Z"
        fill="#F1BE96"
      />
      <path
        d="M103.731 23.9c-1.637-.219-.409 5.675-1.433 6.33-1.023.873-1.432-3.711-3.07-3.711-2.455 0-2.045 6.55-2.864-.437-.819-8.077 1.637-14.845 10.641-14.845 5.935 0 9.618 2.62 11.46 6.986 0 0 1.841 4.803-2.865 5.895-.205 0-4.502 1.091-11.869-.219Z"
        fill="#28211E"
      />
      <path
        opacity=".5"
        d="m87.77 189.594 25.17-5.239-42.77-22.704L45 166.89l42.77 22.704Z"
        fill="url(#servicepoint_christmas_paint0_linear)"
      />
      <path d="m112.939 112.314 75.102-14.408-42.769-22.704L70.17 89.61l42.769 22.704Z" fill="#FDDE84" />
      <path d="M112.939 112.314v72.041L70.17 161.651V89.61l42.769 22.704Z" fill="#C39000" />
      <path d="M112.939 112.314v72.041l75.102-14.408V97.906l-75.102 14.408Z" fill="#FCCE09" />
      <path d="m112.326 110.786 78.376-15.064-44.611-23.577L67.51 87.208l44.816 23.578Z" fill="#996A0D" />
      <path d="M112.326 110.786v4.584L67.51 91.575v-4.366l44.816 23.577Z" fill="#634509" />
      <path d="M112.326 110.786v4.584l78.376-15.063v-4.585l-78.376 15.064Z" fill="#BC9361" />
      <path
        opacity=".5"
        d="m105.982 109.258 12.483-2.62-14.939-7.859-12.483 2.62 14.939 7.859Z"
        fill="url(#servicepoint_christmas_paint1_linear)"
      />
      <path d="m118.465 96.16 14.529-2.62-14.939-7.86-14.529 2.62 14.939 7.86Z" fill="#FDDE84" />
      <path d="M118.465 96.16v10.696l-14.939-8.077V88.3l14.939 7.86Z" fill="#C39000" />
      <path d="M118.465 96.16v10.697l14.529-2.838v-10.48l-14.529 2.62Z" fill="#FCCE09" />
      <path d="m114.372 30.012 1.023 3.93-1.637-.218" fill="#DEA07B" />
      <path
        d="m123.376 148.335 7.572-1.528-.41.655-7.162 1.31v-.437ZM123.376 147.243l8.39-1.746-.409.655-7.981 1.528v-.437ZM123.376 149.427l6.753-1.529-.409.655-6.344 1.31v-.436ZM179.651 137.42l-7.571 1.528.409-.655 7.162-1.528v.655ZM179.651 138.511l-8.39 1.747.409-.655 7.981-1.747v.655ZM173.307 136.983l6.344-1.31v.655l-6.753 1.31.409-.655ZM130.743 148.553l3.683-5.894s4.093-.873 4.502-.873c.41 0 .41 0 .205.436-.205.437-.614 1.092-.819 1.528-.204.219-.409.655.41.437.818-.218 5.934-1.31 5.934-1.31-.409.873-2.046 3.275-5.116 3.711-2.455.655-8.799 1.965-8.799 1.965ZM151.411 141.567l-2.046 3.057-5.116 1.091 2.046-3.274 5.116-.874ZM158.983 140.039l-2.047 3.057-5.115 1.091 2.046-3.056 5.116-1.092ZM160.62 139.603s-.409.654-.614.873c-.614 1.091 0 1.965 2.046 1.528 2.456-.437 8.391-1.747 8.391-1.747l2.046-3.056-11.869 2.402Z"
        fill="#D40511"
      />
      <path
        d="m133.199 139.603-1.842 2.838s9.413-1.965 9.822-1.965c.41 0 .41 0 .205.436-.205.437-.614 1.092-.818 1.529-.205.218-.41.655.409.436.818-.218 4.093-.873 4.093-.873s.613-1.092 1.227-1.965c.819-1.091 0-3.274-2.66-2.619-2.456.654-10.436 2.183-10.436 2.183ZM159.392 139.166l-12.687 2.62 3.478-5.458 5.116-1.092-2.046 3.275 2.456-.655 1.841-3.056 5.321-1.092-3.479 5.458ZM170.033 132.18l-3.479 5.676-5.525 1.092 3.479-5.458 5.525-1.31Z"
        fill="#D40511"
      />
      <path d="m115.19 55.99.614 6.113 3.479.655 2.456-1.965-.614-5.894-5.935 1.092Z" fill="#C9C9C9" />
      <path
        d="M121.125 55.99V54.9l-5.935 1.09.205 1.092M110.893 50.751c.339 0 .614-.293.614-.655 0-.361-.275-.655-.614-.655-.339 0-.614.294-.614.655 0 .362.275.655.614.655ZM111.098 53.59c.339 0 .614-.294.614-.656 0-.361-.275-.655-.614-.655-.339 0-.614.293-.614.655 0 .362.275.655.614.655ZM111.302 56.645c.339 0 .614-.293.614-.654 0-.362-.275-.655-.614-.655-.339 0-.614.293-.614.655 0 .361.275.654.614.654Z"
        fill="#8E8E8E"
      />
      <path
        opacity=".5"
        d="m137.701 95.504 9.208-1.965-15.348-8.077-9.208 1.965 15.348 8.077Z"
        fill="url(#servicepoint_christmas_paint2_linear)"
      />
      <path d="m146.909 67.56 27.012-5.02-15.348-8.296-27.012 5.24 15.348 8.077Z" fill="#FDDE84" />
      <path opacity=".4" d="m140.156 64.068 27.217-5.24-2.66-1.31-27.012 5.24 2.455 1.31Z" fill="#AA7B33" />
      <path d="M146.909 67.561v25.978l-15.348-8.077V59.484l15.348 8.077Z" fill="#C39000" />
      <path opacity=".4" d="M140.156 64.068v5.676l-2.455-1.528v-5.458l2.455 1.31Z" fill="#AA7B33" />
      <path d="M146.909 67.56v25.98l27.012-5.24V62.54l-27.012 5.02Z" fill="#FCCE09" />
      <path d="m140.156 90.046-2.251-1.31-.204-25.978 2.455 1.31v25.978Z" fill="#AF0527" />
      <path d="m164.713 57.519-27.012 5.24 2.455 1.309 27.217-5.24-2.66-1.31Z" fill="#D2002E" />
      <path d="m158.778 91.356 2.865-.655.205-25.978-2.865.655-.205 25.978Z" fill="#AF0527" />
      <path d="m147.114 56.427 14.734 8.296-2.865.655-14.734-8.296 2.865-.655Z" fill="#D2002E" />
      <path
        d="M151.002 60.357s-5.73-.437-7.162-.437c-1.433 0-2.251.873-2.251 1.747 0 .873.818 1.528 1.432 1.964.819.437 3.888 2.62 3.888 2.62l6.139-4.366-2.046-1.528Z"
        fill="#D2002E"
      />
      <path
        d="M153.253 61.667s-2.865.655-4.297.873c-1.433.218-2.865.655-2.456 2.401.205 1.747 2.046 1.092 3.069.219.819-.655 3.684-3.493 3.684-3.493Z"
        fill="#AF0527"
      />
      <path
        d="M151.82 60.138s1.638-4.584 2.047-5.675c.409-1.092 1.023-2.184 2.046-1.747 1.023.437 5.525 3.056 5.525 3.056l-7.776 5.676-1.842-1.31Z"
        fill="#D2002E"
      />
      <path
        d="M153.662 61.448s4.298-4.148 4.912-4.803c.613-.655 2.66-1.746 2.864-.436 0 1.528-1.023 1.965-2.251 2.62-1.432.873-5.525 2.62-5.525 2.62ZM144.658 60.357l6.549.218.818.873-4.707 1.092 3.479-1.092-2.251-.218 1.637-.218-5.525-.655ZM152.639 59.92l1.842-4.584-1.228 4.148.819-1.092-.41 1.091 1.228-1.746-.818 1.965 3.478-3.056-3.888 3.93-1.023-.656Z"
        fill="#AF0527"
      />
      <path
        d="M153.867 60.139c.614.436.614 1.091 0 1.528-.614.436-1.842.436-2.456 0-.614-.437-.614-1.092 0-1.529.614-.436 1.637-.436 2.456 0Z"
        fill="#D2002E"
      />
      <path
        d="M154.072 61.448c-.614.437-1.842.437-2.456 0-.409-.218-.614-.655-.409-1.091-.41.436-.205.873.204 1.31.614.436 1.842.436 2.456 0 .205-.219.409-.219.409-.437 0 0-.204 0-.204.218Z"
        fill="#AF0527"
      />
      <path d="m112.121 103.364-2.251-1.092-.205-10.697 2.661 1.31-.205 10.479Z" fill="#0E248C" />
      <path d="m123.99 88.737-14.325 2.838 2.661 1.31 14.12-2.838-2.456-1.31Z" fill="#4B67BF" />
      <path d="m124.604 105.546 2.865-.436V94.63l-3.07.438.205 10.478Z" fill="#0E248C" />
      <path d="m113.144 86.554 14.325 8.077-3.07.437-14.12-8.078 2.865-.436Z" fill="#4B67BF" />
      <path
        d="M116.623 90.047s-5.73-.437-7.162-.437c-1.433 0-2.251.873-2.251 1.747 0 .873.818 1.528 1.432 1.964.819.437 3.888 2.62 3.888 2.62l6.139-4.366-2.046-1.528Z"
        fill="#4B67BF"
      />
      <path
        d="M118.874 91.357s-2.865.655-4.297.873c-1.433.218-2.865.655-2.456 2.401.205 1.747 2.046 1.092 3.07.219.818-.655 3.683-3.493 3.683-3.493Z"
        fill="#0E248C"
      />
      <path
        d="M117.237 89.828s1.637-4.584 2.046-5.676c.41-1.091 1.023-2.183 2.047-1.746 1.023.655 5.525 3.056 5.525 3.056l-7.572 5.676-2.046-1.31Z"
        fill="#4B67BF"
      />
      <path
        d="M119.283 91.138s4.298-4.148 4.912-4.802c.614-.655 2.66-1.747 2.865-.437 0 1.528-1.024 1.965-2.251 2.62-1.433.873-5.526 2.62-5.526 2.62ZM110.075 90.047l6.753.218.614.873-4.502 1.092 3.478-1.092h-2.251l1.637-.436-5.729-.655ZM118.055 89.61l1.842-4.584-1.228 4.148.819-1.092-.409 1.092 1.227-1.747-.818 1.965 3.479-3.056-3.888 3.929-1.024-.655Z"
        fill="#0E248C"
      />
      <path
        d="M119.488 89.828c.614.437.614 1.092 0 1.529-.614.436-1.842.436-2.456 0-.614-.437-.614-1.092 0-1.529.614-.436 1.637-.436 2.456 0Z"
        fill="#4B67BF"
      />
      <path
        d="M119.488 91.138c-.614.437-1.842.437-2.456 0-.409-.218-.614-.655-.409-1.091-.409.436-.205.873.205 1.31.614.436 1.841.436 2.455 0 .205-.219.41-.219.41-.437l-.205.218Z"
        fill="#0E248C"
      />
      <path
        d="M91.248 5.78s-1.637 0-3.07.437c-1.432.436-.818 2.838-.614 5.02.41 2.184 2.865 14.19 2.865 14.19l1.228-.436 2.251-15.5s.205-3.493-2.66-3.711Z"
        fill="#EB2028"
      />
      <path
        opacity=".4"
        d="M89.61 7.308c-1.84.218.82 5.021 1.638 8.514.614 2.62.205 6.986.205 9.387h.204l2.251-15.5v-.218c-1.637-1.31-3.274-2.183-4.297-2.183Z"
        fill="#90191C"
      />
      <path
        d="M117.237 10.364s-4.297-8.077-9.618-9.387c-5.321-1.091-19.44 5.021-19.44 5.021S91.248 8.4 92.27 8.836c1.023.437 2.456 6.986 2.456 8.732 0 1.747 19.645-1.746 22.51-7.204Z"
        fill="#EB2028"
      />
      <path
        opacity=".4"
        d="M102.503 15.822s-5.116-1.746-5.525-3.056c-.41-1.528 1.842-4.803 1.637-5.458-.205-.436-5.32 0-9.209-.218 1.023.655 2.251 1.746 2.865 1.965 1.023.436 2.456 6.985 2.456 8.732 0 .655 3.888.437 8.595-.655l-.819-1.31Z"
        fill="#90191C"
      />
      <path
        d="M94.727 16.695c-.614 0-.819.219-.819 1.092 0 .873.614 5.894 1.842 6.55 1.228.436 3.274.654 6.753 0 3.274-.656 12.892-3.712 14.939-4.804 2.046-1.091 2.455-1.964 2.251-3.93 0-1.964-1.228-5.239-1.638-5.675-.409-.655-1.432.218-2.251.655-.818.436-5.32 2.62-10.231 3.93-4.707 1.09-9.823 2.182-10.846 2.182Z"
        fill="#EBEBEC"
      />
      <path
        d="M117.442 19.533c1.432-.873 2.046-1.528 2.251-2.62l-1.024 1.092c-.204.437-1.432.873-1.841.655-.41 0-2.251.437-2.661 1.091-.409.655-2.865 1.31-3.478.874-.614-.219-1.842.218-3.275 1.31-1.432.873-4.092-.219-5.116-.437-1.023-.218-.818-.655-1.841-1.092-1.023-.436-.819-.873-.819-.873 0-.218.614-.655-.41-.873-1.022-.218 0-2.62 0-2.62-2.25.437-4.092.873-4.706.873-.614 0-.818.219-.818 1.092 0 .873.614 5.894 1.841 6.55 1.228.436 3.275.654 6.753 0 3.684-.874 13.302-4.149 15.144-5.022Z"
        fill="#D3D4D6"
      />
      <path
        d="m118.465 10.801-.41-.873c-.409-.655-1.432.218-2.251.655-.818.436-5.32 2.62-10.231 3.93-4.912 1.31-10.028 2.4-11.05 2.4-.615 0-.615.219-.82 1.092.615-.218 1.228-.218 1.638 0 .818.437 2.046-.436 2.865 0 .818.219 1.637 0 2.251-.436.818-.437 1.432-.874 1.841-.874.614 0 1.638-.218 1.842-.218.409 0 2.456-.873 4.093-.873s1.637-.655 2.251-.873c.614-.219 1.637-.874 2.046-.874.41 0 3.07-1.091 3.479-1.31.409-.218 1.023-1.091 1.023-1.091s1.023-.437 1.433-.655Z"
        fill="#fff"
      />
      <path
        d="M94.727 26.083c0 1.746-1.433 3.056-3.274 3.056-1.842 0-3.275-1.31-3.275-3.056 0-1.747 1.433-3.057 3.275-3.057 1.841 0 3.274 1.31 3.274 3.057Z"
        fill="#EBEBEC"
      />
      <path
        d="m93.908 28.047-.204-.218c-.205-.218-1.024 0-1.024.218 0 0-1.227.655-1.432-.218-.205-.873-1.228-.437-2.251-.655-1.023-.218 1.023-2.838 1.228-3.056l-.205-.655c-1.023.436-1.637 1.528-1.637 2.838 0 1.746 1.433 3.056 3.274 3.056.819-.218 1.637-.655 2.251-1.31Z"
        fill="#D3D4D6"
      />
      <path
        d="M94.522 24.991c-.41-1.091-1.637-1.965-3.07-1.965-1.636 0-3.069 1.31-3.273 2.838.409-.436 1.023-.655 1.227-.436.205.218.41-.437.819-.655.41-.218 1.637 0 1.637 0s.614-.655 1.432 0c.205 0 .614.218 1.228.218Z"
        fill="#fff"
      />
    </g>
    <defs>
      <linearGradient
        id="servicepoint_christmas_paint0_linear"
        x1="75.258"
        y1="183.393"
        x2="83.48"
        y2="168.268"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".269" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".511" stopColor="#181816" stopOpacity=".364" />
        <stop offset=".817" stopColor="#080807" stopOpacity=".825" />
        <stop offset=".933" />
      </linearGradient>
      <linearGradient
        id="servicepoint_christmas_paint1_linear"
        x1="102.954"
        y1="107.794"
        x2="106.986"
        y2="100.377"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".269" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".511" stopColor="#181816" stopOpacity=".364" />
        <stop offset=".817" stopColor="#080807" stopOpacity=".825" />
        <stop offset=".933" />
      </linearGradient>
      <linearGradient
        id="servicepoint_christmas_paint2_linear"
        x1="133.302"
        y1="93.247"
        x2="136.264"
        y2="87.797"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".269" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".511" stopColor="#181816" stopOpacity=".364" />
        <stop offset=".817" stopColor="#080807" stopOpacity=".825" />
        <stop offset=".933" />
      </linearGradient>
      <clipPath id="servicepoint_christmas_paint0_clip">
        <path fill="#fff" transform="translate(0 .847)" d="M0 0h254v188.315H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)
